import SimpleModel from './SimpleModel'; // Assuming SimpleModel is imported from a local file

/**
 * CMSUser class extends SimpleModel to represent a user in the CMS system.
 * It initializes user data and provides methods to interact with the user's information.
 */
class CMSUser extends SimpleModel {
    /**
     * Constructor for CMSUser class.
     * @param {Object} ndata - The initial data for the user.
     */
    constructor(ndata) {
        super();
        this.data = ndata;
        this.init();
    }

    /**
     * Initializes the user data by setting readable fields.
     * @returns {CMSUser} The current instance of CMSUser.
     */
    init() {
        this.readables({
            'firstName': String,
            'lastName': String,
            'IAA': Object,
            'type': String,
            'groups': Object,
            'permissions': Object
        });

        return this;
    }

    /**
     * Gets the complete name of the user.
     * @param {boolean} [no_html_encoding=false] - Whether to skip HTML encoding.
     * @returns {string} The complete name of the user, optionally encoded for HTML.
     */
    getCompleteName(no_html_encoding = false) {
        // SMELL: Implicit conversion to boolean might be confusing. Consider explicit check.
        no_html_encoding = Boolean(no_html_encoding);

        const name = [this.getFirstName(), this.getLastName()].join(' ');
        return no_html_encoding ? name : encode(name);
    }
}

export default CMSUser;